<template>
  <div class="indexBox w-per100 bg_fff c_333 ox-h relative">
    <!-- banner -->
    <div class="w-per100 relative h500">
      <el-carousel ref="bannershow" :height="'500px'" autoplay arrow="never" :interval="2000">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="w-vw100 h500 column flex-center relative">
            <div class="w-per100 h500">
              <img class="w-per100 h500" :src="item.thumb" alt="" @click.stop="handleShow(index+1)"/>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 我们的优势 -->
    <div id="index1" class="index1 column a-center w-per100 h776">
      <div class="w-per62_5 column a-center">
        <div class="mt120 c_1F2937 ft36 bolder">我们的优势</div>
        <div class="mt36 c_1F2937 ft30">跨区域无缝执行</div>
        <div class="w-per100 row j-sb mt60 gap-0-24">
          <div
            v-for="(item,index) in advantageList"
            :key="index"
            class="advantage-card h350 bg_fff shadow-index1 br12 column a-center px50 index1-adv-card"
            :style="{ animationDelay: 0.15 * (index + 1) + 's' }"
          >
            <img class="wh80 mt80" :src="item.thumb" :alt="item.title" />
            <div class="mt30 ft20 c_333 text_center word_break">{{ item.title }}</div>
            <div class="mt16 ft18 c_666 lh26 text_center word_break">
              {{ item.introduce }}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 多场景下全覆盖的用户流动量 / 线上线下双轨闭环 -->
    <div id="index2" class="index2 column a-center w-per100 h1000">
      <div class="w-per62_5 column a-center">
        <div class="c_1F2937 ft30">线上线下双轨闭环</div>
        <div class="mt16 c_4B5563 ft16">
          打通线上+线下用户触点，为品牌构建可持续的闭环营销体系
        </div>
        <div class="row a-center mt40 scene-tab-group bg_fff br20">
          <div
            v-for="tab in sceneTabs"
            :key="tab.value"
            class="py8 br20 pointer flex1 text_center"
            :class="sceneType === tab.value ? 'bg_F97316 c_fff' : 'bg_fff c_4B5563'"
            @click="sceneType = tab.value"
          >
            {{ tab.label }}
          </div>
        </div>
        <div class="mt24 c_4B5563 ft16" v-if="sceneType === 'online'">
          线上借社交媒体精准引流，精准定位目标人群，通过微信、微博、抖音等平台实现高效引流
        </div>
        <div class="mt24 c_4B5563 ft16" v-else>
          以车展、社区摆展、地推等方式优化体验，再通过数据追踪开展 ROI 分析，优化策略，提升营销效益
        </div>
        <!-- 线上场景 -->
        <div v-if="sceneType === 'online'" class="w-per100 mt32">
          <div class="w-per100 column j-sb wrap h520">
            <div
              v-for="(item, index) in onlineSceneList"
              :key="item.title"
              class="online-card br12 bg_fff relative o-h"
              :class="index === 0?'h520':'h250'"
              :style="{ backgroundImage: 'url(' + (item.images ? item.images[0] : '') + ')' }"
            >
              <div class="column j-sb h-per100 br12">
                <div class="c_fff ft24 px24 py32">{{ item.title }}</div>
                <div class="row a-center px24 py24">
                  <img class="wh52 mr12" :src="item.thumb" :alt="item.introduce" />
                  <div class="c_fff ft20">{{ item.introduce }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 线下场景 -->
        <div v-else class="w-per100 h520 br12 o-h mt32">
          <div class="row wrap">
            <div
              v-for="item in offlineSceneList"
              :key="item.title"
              class="offline-card w-per33 h260 relative o-h"
            >
              <div class="column j-end h-per100 px24 py24 offline-card-box" :style="{ backgroundImage: 'url(' + (item.images ? item.images[0] : '') + ')' }">
                <div class="c_fff ft18">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业深度定制 -->
    <div id="index3" class="index3 column a-center w-per100 h810 mt-100">
      <div class="w-per62_5 column a-center">
        <div class="c_1F2937 ft30">行业深度定制</div>
        <div class="mt20 c_4B5563 ft16">
          根据不同汽车业态与场景，提供专业定制化营销解决方案
        </div>
        <div class="w-per100 row j-sb mt60">
          <div
            v-for="(item,index) in industryList"
            :key="index"
            ref="index3Card"
            class="index3-card bg_fff br12 column h550 shadow-index3"
          >
            <img class="w-per100 h300" :src="item.images?item.images[0]:''" />
            <div class="column mt-12 px24 pb24">
              <img class="wh80" :src="item.thumb" :alt="item.title" />
              <div class="c_333 ft24 mt16">{{ item.title }}</div>
              <div class="c_4B5563 ft16 lh28 mt16">
                {{ item.introduce }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div id="contactUs" class="consultBox column a-center w-per100 h944">
        <div class="c_1F2937 ft36">联系我们</div>
        <div class="mt16 c_4B5563 ft20">
          如果您有相关需求，欢迎留下您的联系方式
        </div>
        <div class="w-per100 h750 mt50 row bgBox">
          <!-- 左侧地图图片 -->
          <!-- <img class="w-per50 h-per100" src="@/assets/image/index3.png" alt=""> -->
          <!-- 右侧表单与信息 -->
          <div class="w-per100 h-per100 column a-center">
            <div class="mt60 w800 column a-center">
              <div class="c_333 ft30 mb40">留言</div>
              <el-input
                v-model="contactMessage"
                type="textarea"
                :rows="10"
                placeholder="请输入您的留言内容"
                class="w-per100 contact-textarea"
              ></el-input>
              <div
                class="w-per100 mt60 py11 br8 bg_F97316 c_fff ft18 text_center pointer"
                @click="submitContact"
              >
                提交
              </div>
              <!-- <div class="mt26 w-per100">
                <div class="row a-center py34 bdb_9CA3AF">
                  <img class="wh56 mr16" src="@/assets/image/icon_dianhua.png" alt="电话" />
                  <div class="column">
                    <div class="c_999 ft17">电话</div>
                    <div class="c_333 ft18 mt8">{{ otherdata.phone }}</div>
                  </div>
                </div>
                <div class="row a-center py34 bdb_9CA3AF">
                  <img class="wh56 mr16" src="@/assets/image/icon_dizhi.png" alt="地址" />
                  <div class="column">
                    <div class="c_999 ft17">地址</div>
                    <div class="c_333 ft18 mt8">{{ otherdata.address }}</div>
                  </div>
                </div>
                <div class="row a-center py34 bdb_9CA3AF">
                  <img class="wh56 mr16" src="@/assets/image/icon_youxiang.png" alt="邮箱" />
                  <div class="column">
                    <div class="c_999 ft17">邮箱</div>
                    <div class="c_333 ft18 mt8">{{ otherdata.email }}</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
    </div>

    <!-- footer -->
    <my-footer :current="current" @onScrollTo="scroll"></my-footer>

  </div>
</template>

<script>
import { getCategoryList, getCategoryData, getConfig, leaveMessage } from "@/api/app"

export default {
  metaInfo() {
    return {
      title: '徐州车展家',
      meta: [
        {
          name: "keywords",
          content: this.PagekeyWords,
        },
        {
          name: "description",
          content: this.PageDescription,
        },
        {
          property: "og:type",
          content: 'website',
        },
        {
          property: "og:title",
          content: this.PageTitle,
        },
        {
          property: "og:description",
          content: this.PageDescription,
        },
        {
          property: "og:site_name",
          content: this.PageTitle,
        },
        {
          property: "og:url",
          content: 'https://www.xzczj.com/#/',
        },
        {
          property: "og:image",
          content: 'https://www.xzczj.com/czj/favicon.ico',
        },
      ],
    };
  },
  data() {
    return {
      PageTitle: "",
      PagekeyWords: "",
      PageDescription: "",
      banners: [],
      current: 0,
      otherdata:{
        phone: "",
        address: "",
        email: "",
      },
      advantageList: [],
      sceneType: "online",
      sceneTabs: [
        { value: "online", label: "线上场景" },
        { value: "offline", label: "线下场景" },
      ],
      onlineSceneList: [],
      offlineSceneList: [],
      industryList: [],
      contactMessage: "",
    }
  },
  mounted() {
    this.fetchConfig()
    this.current = 0
    this.fetchIndex();
  },
  methods: {
    async submitContact() {
      if (!this.contactMessage || !this.contactMessage.trim()) {
        this.$message.error("请输入您的留言内容");
        return;
      }
      const loading = this.$loading({ lock: true, text: "提交中..." });
      try {
        await leaveMessage(this.contactMessage.trim());
        this.$message.success("提交成功");
        this.contactMessage = "";
      } catch (e) {
        this.$message.error(e?.response?.data?.message || "提交失败，请稍后重试");
      } finally {
        loading.close();
      }
    },
    // 导航栏切换
    handleShow(index,id) {
      // console.log(index)
      this.current = index
      if (index == 1) {
        this.$router.push({
          path: "/service",
        })
        this.handelUpdate()
      }
      if (index == 2) {
        this.$router.push({
          path: "/activity",
        })
      }
      if (index == 3) {
        this.$router.push({
          path: "/overall",
        })
      }
      if (index == 4) {
        this.$router.push({
          path: "/aboutus",
        })
      }
      this.handelUpdate()
      if(id){
        setTimeout(()=>{
          const el = document.getElementById(id)
          const container = document.querySelector('.main')
          this.$nextTick(function () {
            if (!container || !el) return
            container.scrollTo({
              behavior: "smooth",
              top: el.offsetTop + -88,
              left: 0,
            })
          })
        },100)
      }
    },
    // 回顶部
    handelUpdate() {
      const container = document.querySelector('.main')
      if (!container) return
      container.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    },
    // 滚动到某版块
    scroll({id, offset, num}) {
      if (num == -1) {
        offset = offset || -10
        const el = document.getElementById(id)
        const container = document.querySelector('.main')
        this.$nextTick(function () {
          if (!container || !el) return
          container.scrollTo({
            behavior: "smooth",
            top: el.offsetTop + offset,
            left: 0,
          })
        })
      } else {
        this.handleShow(num,id)
      }
    },
    // 首页
    async fetchIndex() {
      let {data} = await getCategoryList()
      let list = data.data.list;
      console.log("list", list);
      let sy = list.find(item => item.catname === '首页');
      let params = {id:sy.id}
      let {data:data2} = await getCategoryData(params)
      console.log("data2", data2);
      this.banners = data2.data.category.data;

      let children = data2.data.children;
      let advantage = children.find(item => item.catname === '我们的优势');
      this.advantageList = advantage.data;
      let line = children.find(item => item.catname === '线上线下双规闭环');
      this.onlineSceneList = line.children[0].data;
      this.offlineSceneList = line.children[1].data;
      let industry = children.find(item => item.catname === '行业深度定制');
      this.industryList = industry.data;

      // 数据渲染完成后再初始化进场动画
      this.$nextTick(() => {
        this.initIndex3Animation && this.initIndex3Animation()
      })
    },
    async fetchConfig() {
      let params = {name: 'phone,address,email,wz_keyword,zd_desc,zd_name'}
      let {data} = await getConfig(params)
      this.otherdata.phone = data.data.list.phone;
      this.otherdata.address = data.data.list.address;
      this.otherdata.email = data.data.list.email;
      this.PageTitle = data.data.list.zd_name;
      this.PagekeyWords = data.data.list.wz_keyword;
      this.PageDescription = data.data.list.zd_desc;
    },
    // 行业深度定制卡片进场动画
    initIndex3Animation() {
      const cards = this.$refs.index3Card
      if (!cards || (Array.isArray(cards) && cards.length === 0)) return

      const list = Array.isArray(cards) ? cards : [cards]

      if (!('IntersectionObserver' in window)) {
        list.forEach(el => el.classList.add('index3-card--show'))
        return
      }

      const container = document.querySelector('.main') || null

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('index3-card--show')
              observer.unobserve(entry.target)
            }
          })
        },
        {
          threshold: 0.2,
          root: container || null,
        }
      )

      list.forEach(el => observer.observe(el))
    },
  },
}
</script>

<style scoped lang="scss">
.indexBox {
  margin: 0px;

  .index1{
    background-image: url('@/assets/image/bg-index1.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .advantage-card{
      width: calc((100% - 48px) / 3);
    }
    .advantage-card:hover{
      transform: scale(1.05);
      transition: all 0.3s ease;
    }
  }
  .index2{
    background-image: url('@/assets/image/bg-index2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .scene-tab-group {
    width: 300px;
  }

  .online-card {
    width: calc((100% - 48px) / 3);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .online-card:hover{
    transform: scale(1.05);
    transition: all 0.3s ease;
  }

  .offline-card {
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .offline-card:hover{
    .offline-card-box{
      transform: scale(1.1);
      transition: all 0.3s ease;
    }
  }
  .index3{
    .index3-card{
      width: calc((100% - 48px) / 3);
      opacity: 0;
      transform: translateY(100px);
      transition: opacity 0.6s ease 0.3s, transform 0.6s ease 0.3s;
    }
    .index3-card--show{
      opacity: 1;
      transform: translateY(0);
    }
  }

  .index1-adv-card {
    opacity: 0;
    transform: scale(0.5);
    animation: index1-adv-in 0.6s ease-out forwards;
  }
}

@keyframes index1-adv-in {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

  .consultBox{
    .bgBox{
      background-image: url('@/assets/image/bg-index4.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    ::v-deep .contact-textarea .el-textarea__inner{
      height: 310px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #9CA3AF;
      font-size: 17px;
      color: #333333;
      line-height: 21px;
    }
    ::v-deep .contact-textarea .el-textarea__inner::placeholder{
      color: #999999;
    }
  }


/* banner指示器 */
::v-deep .el-carousel__indicator--horizontal .el-carousel__button.el-carousel__button {
  width: 30px !important;
  height: 4px !important;
  background: #F97316;
  border-radius: 0px 0px 0px 0px;
}
</style>
